module.exports = __webpack_public_path__ + "img/my_build_edit-attributes.bbef1770.jpg";